import { Injectable } from '@angular/core';

@Injectable()
export class WebRTCConfiguration {
    public get socketUrl(): string {
        return "https://skynetix-server-docker.azurewebsites.net/";
    }
}
